<template>
  <div>
    <el-tabs v-model="activeName" class="trigger-tabs">
      <el-tab-pane label="疾病药物" name="first" :lazy="true">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <el-row>
                  <el-select class="select-offset-large" v-model="selForm.sel_diag" placeholder="请选择疾病">
                    <el-option v-for="item in options_diags"
                               :key="item.mr_diagnosis"
                               :label="item.mr_diagnosis"
                               :value="item.mr_diagnosis">
                    </el-option>
                  </el-select>

                  <el-select class="select-offset" v-model="selForm.sel_med_type" placeholder="请选择药物类型">
                    <el-option
                        v-for="option in medTypeOptions"
                        :key="option.value || option.label"
                        :label="option.label"
                        :value="option.value">
                    </el-option>
                  </el-select>

                  <el-button type="primary" class="primary-action-btn" @click="stat_tf">开出药物统计
                  </el-button>
                </el-row>

                <el-row>
                  <el-row :gutter="20" class="chart-row">
                    <el-col v-for="chart in chartConfigs" :key="chart.id" :span="12">
                      <PieChart :id="chart.id" :params="selForm" :key="chart.id + '-' + selKey"
                                height="350px" width="100%"
                                :path="chart.path"></PieChart>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15">
                    <el-col v-for="table in tiefuTables" :key="table.key" :span="12">
                      <el-table :data="table.data" style="width: 100%"
                                :header-cell-style="tableHeaderStyle"
                                :row-class-name="tableRowClassName">
                        <el-table-column
                            v-for="column in tiefuColumns"
                            :key="column.prop"
                            :prop="column.prop"
                            :label="column.label">
                        </el-table-column>
                      </el-table>
                    </el-col>
                  </el-row>
                </el-row>

              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane label="收入处方" name="second" :lazy="true">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <el-row>
                  <el-select class="select-offset-medium" v-model="selForm.sel_province" @change="get_city"
                             placeholder="请选择省份">
                    <el-option v-for="item in options_province"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select class="select-offset" v-model="selForm.sel_city" placeholder="请选择市地">
                    <el-option v-for="item in options_city"
                               :key="item.value"
                               :label="item.label"
                               :value="item.label">
                    </el-option>
                  </el-select>
                  <el-date-picker class="select-offset"
                                  v-model="selForm.date_span"
                                  type="daterange"
                                  align="right"
                                  unlink-panels
                                  value-format="yyyy-MM-dd"
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  :picker-options="pickerOptions">
                  </el-date-picker>
                  <el-button type="primary" class="primary-action-btn" @click="query">查询
                  </el-button>
                </el-row>
                <el-row :gutter="20">
                  <el-col v-for="card in statCards" :key="card.key" :span="24">
                    <el-card class="box-card" shadow="hover">
                      <div slot="header" class="clearfix">
                        <i class="el-icon-card-header-red"></i>
                        <span>{{ card.title }}</span>
                      </div>
                      <el-table :data="card.data" style="width: 100%"
                                height="300px"
                                :header-cell-style="tableHeaderStyle"
                                :row-class-name="tableRowClassName">
                        <template v-for="column in card.columns">
                          <el-table-column
                              v-if="!column.isAction"
                              :key="column.key + '-data'"
                              v-bind="column.columnProps">
                          </el-table-column>
                          <el-table-column v-else :key="column.key + '-action'" :label="column.label">
                            <template slot-scope="scope">
                              <el-button @click="open_detail(scope.row)" type="text" class="action-text-btn"
                                         size="small">{{ column.actionLabel }}
                              </el-button>
                            </template>
                          </el-table-column>
                        </template>
                      </el-table>
                    </el-card>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from "moment-timezone";
import PieChart from "@/views/charts/pie";
import '@/assets/css/main.css';

import { buildAppWebUrl } from '@/utils/appWebUrl';

const API_HOST = process.env.VUE_APP_API_HOST;
const JSON_HEADERS = {"content-type": "application/json"};
const MED_TYPE_OPTIONS = [
  {value: '', label: '全部'},
  {value: '1', label: '西药处方'},
  {value: '2', label: '九和饮'},
  {value: '3', label: '注射处方'},
  {value: '4', label: '费用'},
  {value: '5', label: '检查'},
  {value: '6', label: '检验'},
  {value: '7', label: '治疗'},
  {value: '8', label: '理疗'},
  {value: '9', label: '中药处方'},
  {value: '10', label: '贴敷处方'},
  {value: '11', label: '材料'},
];
const CHART_CONFIGS = [
  {id: 'user_profile_city_disease_predict', path: 'trigger_stat_tf_pie'},
  {id: 'user_profile_city_acupoint_stat', path: 'trigger_stat_acupoint_pie'}
];
const TIEFU_COLUMNS = [
  {prop: 'index', label: '序号'},
  {prop: 'name', label: '药名'},
  {prop: 'value', label: '数量'}
];
const STAT_TABLE_BASE_COLUMNS = [
  {
    key: 'index',
    columnProps: {type: 'index', prop: 'order', label: '序号', width: '120', align: 'center'}
  },
  {key: 'clinic_id', columnProps: {prop: 'clinic_id', label: '诊所ID'}},
  {
    key: 'clinic_name',
    columnProps: {prop: 'clinic_name', label: '诊所名称', showOverflowTooltip: true}
  },
  {key: 'new_shengqu_name', columnProps: {prop: 'new_shengqu_name', label: '省区'}},
  {key: 'new_diban_name', columnProps: {prop: 'new_diban_name', label: '地办'}}
];

export default {
  name: "TriggerView",
  components: {
    PieChart
  },
  data() {
    return {
      activeName: "first",
      selForm: {
        date_span: [
          moment().subtract(7, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        sel_province: '',
        sel_city: '',
        sel_dim: '',
        sel_diag: '',
        sel_med_type: '',
      },
      chufangTbl: [],
      feeTbl: [],
      options_province: [],
      options_city: [],
      options_diags: [],
      selKey: "",
      tiefuTbl: [],
      medTypeOptions: MED_TYPE_OPTIONS,
      chartConfigs: CHART_CONFIGS,
      tiefuColumns: TIEFU_COLUMNS,
      tableHeaderStyle: {background: '#363944', color: 'white', border: 'none'},
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  computed: {
    tiefuLeft() {
      const half = Math.floor(this.tiefuTbl.length / 2);
      return this.tiefuTbl.slice(0, half);
    },
    tiefuRight() {
      const half = Math.floor(this.tiefuTbl.length / 2);
      return this.tiefuTbl.slice(half);
    },
    tiefuTables() {
      return [
        {key: 'left', data: this.tiefuLeft},
        {key: 'right', data: this.tiefuRight}
      ];
    },
    statCards() {
      return [
        {
          key: 'chufang',
          title: '开方量-top10',
          data: this.chufangTbl,
          metric: {prop: '开方量', label: '开方量'}
        },
        {
          key: 'fee',
          title: '收入-top10',
          data: this.feeTbl,
          metric: {prop: '收入', label: '收入'}
        }
      ].map((card) => ({
        ...card,
        columns: [
          ...STAT_TABLE_BASE_COLUMNS,
          {key: card.metric.prop, columnProps: {prop: card.metric.prop, label: card.metric.label}},
          {key: 'action', isAction: true, label: '操作', actionLabel: '详情'}
        ]
      }));
    }
  },
  methods: {
    open_detail(row) {
      window.open(
        buildAppWebUrl(`/clinic/clinic_info?doctor_id=-1&clinic_id=${row.clinic_id}`),
        '_blank',
        'noopener,noreferrer'
      );
    },
    get_province() {
      this.$http.get(API_HOST + "/get_shengqu").then((res) => {
        this.options_province = res.data.data
      })
    },
    get_city() {
      this.selForm.sel_city = ''
      this.$http.get(API_HOST + "/get_diban?province_id=" + this.selForm.sel_province).then((res) => {
        this.options_city = res.data.data
      })
    },
    get_diags() {
      this.selForm.sel_city = ''
      this.$http.post(API_HOST + "/trigger_diags", this.selForm).then((res) => {
        console.log(res)
        this.options_diags = [{cnt: '',mr_diagnosis:"全部"}].concat(res.data.data)
// "支气管炎"}]res.data.data
      })

    },
    query() {
      this.$http.post(API_HOST + "/trigger_stat", this.selForm, JSON_HEADERS).then((res) => {
        this.chufangTbl = res.data.chufangTbl
        this.feeTbl = res.data.feeTbl
      })
      this.get_diags()
    },
    stat_tf() {
      this.selKey = Date.now();
      this.$http.post(API_HOST + "/trigger_stat_tf", this.selForm, JSON_HEADERS).then((res) => {
        this.tiefuTbl = res.data.tiefuTbl
      })
      this.get_diags()
    },

    tableRowClassName({rowIndex}) {
      return rowIndex % 2 === 1 ? 'warning-row1' : 'success-row1';
    },
  },
  mounted() {
    this.get_province();
    this.get_diags();
    this.query();
    this.stat_tf();
  }
}
</script>

<style scoped>
.trigger-tabs {
  margin-top: 10px;
  margin-left: 10px;
}

.primary-action-btn {
  margin-left: 20px;
  background-color: rgb(46, 205, 129);
  border-color: rgb(46, 205, 129);
  color: white;
}

.select-offset-large {
  margin-left: 250px;
}

.select-offset-medium {
  margin-left: 120px;
}

.select-offset {
  margin-left: 20px;
}

.chart-row {
  height: 350px;
  width: 100%;
  margin-top: 10px;
}

.action-text-btn {
  color: rgb(46, 205, 129);
}

:deep(.el-table tbody tr:hover) {
  color: black !important
}

:deep(.el-table .warning-row1) {
  background: #363944;
}

:deep(.el-table .warning-row1 > td) {
  border: none;
}

:deep(.el-table .success-row1) {
  background: #3C3F4A;
}

:deep(.el-table .success-row1 > td) {
  border: none;
}

:deep(.el-card .el-card__header) {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

:deep(.el-card .el-card__body) {
  background-color: #363944;
}


:deep(.el-tabs__item) {
  color: white !important;
  font-size: 20px;
}

:deep(.el-tabs__item.is-active) {
  color: white !important;
  font-size: 20px;
}

:deep(.el-tabs__active-bar) {
  background-color: #68F5B9 !important;

}
</style>
